import React from "react";
import "./Footer.css";
import {useTranslation} from "react-i18next";

const Footer = () => {

    const {t} = useTranslation();

    return (
        <>
            <footer className="bg-[#163578] mt-auto">
                <div className="flex flex-col container mx-auto p-4">
                    <div className="lg:grid lg:grid-cols-2 border-b border-b-white py-6">
                        <div className="hidden lg:grid content-center">
                            <img className="mx-auto w-[300px]" src={"/logo/" + t("root.footer-logo")}
                                 alt="mongolbank.mn"/>
                        </div>
                        <div className="text-white">
                            <div className="">
                                <p className="text-xl font-bold">{t('footer.item1')}</p>
                                <p className="my-3">{t('footer.item2')}</p>
                            </div>
                            <div className="md:grid md:grid-cols-2 mt-4">
                                <div>
                                    <p className="font-bold">{t('footer.item3')}</p>
                                    <p>{t('footer.item5')}: {t('footer.item7')}</p>
                                    <p>{t('footer.item6')}: {t('footer.item9')}</p>
                                </div>
                                <div className="mt-2 md:mt-0">
                                    <p className="font-bold">{t('footer.item4')}</p>
                                    <p>{t('footer.item5')}: {t('footer.item8')}</p>
                                    <p>{t('footer.item6')}: {t('footer.item10')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="text-center text-white font-normal my-3">
                        <p>{t('footer.item11')}</p>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;
